import React, { useContext, useReducer, useCallback, useEffect } from "react";
import axios from "axios";
import reducer from "../reducers/nav_reducer";
import { api_v3_user_detail } from "../utils/constants";
import {
  SIDEBAR_OPEN,
  SIDEBAR_CLOSE,
  NAVBAR_OPEN,
  NAVBAR_CLOSE,
  NOTIFICATION_OPEN,
  NOTIFICATION_CLOSE,
  SET_AUTH_TOKENS,
  REFRESH_USER,
  SET_USER,
} from "../actions";

const initialState = {
  isSidebarOpen: false,
  isNavbarOpen: true,
  isNotificationOpen: false,
  accessToken: "",
  refreshToken: "",
  user: null,
};

const NavContext = React.createContext();

export const NavProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const openSidebar = () => {
    console.log(`Open sidebar`);
    dispatch({ type: SIDEBAR_OPEN });
  };

  const closeSidebar = () => {
    dispatch({ type: SIDEBAR_CLOSE });
  };

  const openNavbar = () => {
    console.log(`Open Navbar`);
    dispatch({ type: NAVBAR_OPEN });
  };

  const closeNavbar = () => {
    dispatch({ type: NAVBAR_CLOSE });
  };

  const openNotification = () => {
    console.log(`Open Notification`);
    dispatch({ type: NOTIFICATION_OPEN });
  };

  const closeNotification = () => {
    dispatch({ type: NOTIFICATION_CLOSE });
  };

  const refreshUser = useCallback(async () => {
    //console.log(`refreshUser :: access_token=${state.accessToken}`);

    if (
      !state.accessToken &&
      !state.accessToken.length > 0 &&
      !localStorage.getItem("access_token")
    ) {
      console.error(`User must login`);
      return;
    }

    if (!state.accessToken && !state.accessToken.length > 0) {
    }
    var access_token = !state.accessToken
      ? localStorage.getItem("access_token")
      : state.accessToken;
    /* var refresh_token = !state.refreshToken
      ? localStorage.getItem("refresh_token")
      : state.refreshToken; */

    /* console.log(
      `access_token: ${access_token} | refresh_token: ${refresh_token}`
    ); */

    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };

    try {
      const response = await axios.get(api_v3_user_detail(), config);
      const user = response.data;

      /* console.log(
        `refreshUser :: getUser response (${
          response.status
        }) -> ${JSON.stringify(response.data)}`
      ); */

      localStorage.setItem("user", JSON.stringify(user));
      //console.log(`refreshUser :: user updated in localStorage`);

      window.clarity?.('identify', String(user.playerId));

      dispatch({ type: REFRESH_USER, payload: user });
    } catch (error) {
      console.error(`Error getting user detail: ${error}`);
      if (axios.isAxiosError(error)) {
        if (
          error.response.status === 403 &&
          error.response.data.detail ===
            "JWT validation error: Signature has expired."
        ) {
          console.log("Signature has expired");
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("user");
          window.clarity?.('identify');
          dispatch({ type: REFRESH_USER, payload: null });
        }
        if (!error.response) {
          console.log(
            "Network Error: No se pudo establecer una conexión con el servidor."
          );
        } else {
          console.log(
            `Error HTTP: ${error.response.status} - ${error.response.statusText}`
          );
          if (error.response & error.response.status) {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("user");
            window.clarity?.('identify');
            dispatch({ type: REFRESH_USER, payload: null });
          }
          console.error(error.response.status);
        }
      }
    }
  }, [state.accessToken]);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      refreshUser();
    }
  }, [refreshUser]);

  const setAuthTokens = (access_token, refresh_token) => {
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("refresh_token", refresh_token);
    dispatch({
      type: SET_AUTH_TOKENS,
      payload: { accessToken: access_token, refreshToken: refresh_token },
    });
  };

  const setUser = (user) => {
    dispatch({ type: SET_USER, payload: user });
  };

  return (
    <NavContext.Provider
      value={{
        ...state,
        openSidebar,
        closeSidebar,
        openNavbar,
        closeNavbar,
        openNotification,
        closeNotification,
        setAuthTokens,
        refreshUser,
        setUser,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};

export const useNavContext = () => {
  return useContext(NavContext);
};
